import { useRef } from "react";
import { useFrame } from "@react-three/fiber";

const SHAPES = [
  { type: "torus",       args: [1.6, 0.22, 18, 80],  base: [-5.2,  0.8, -1.0], strength: 0.20, rotSpeed:  0.003, phase: 0.0 },
  { type: "octahedron",  args: [1.5, 0],             base: [ 5.2, -0.6, -1.2], strength: 0.16, rotSpeed: -0.004, phase: 1.8 },
  { type: "icosahedron", args: [1.2, 1],             base: [-4.8, -2.6, -2.0], strength: 0.24, rotSpeed:  0.005, phase: 3.2 },
  { type: "sphere",      args: [1.0, 8, 6],          base: [ 4.8,  2.6, -2.5], strength: 0.12, rotSpeed: -0.003, phase: 0.9 },
];

function Shape({ type, args, base, strength, rotSpeed, phase, mouseRef, color }) {
  const meshRef = useRef();
  const pos = useRef({ x: base[0], y: base[1] });

  useFrame(({ clock }) => {
    if (!meshRef.current) return;

    const { x: mx, y: my } = mouseRef.current;
    const tx = base[0] + mx * strength * 3;
    const ty = base[1] + my * strength * 3;
    pos.current.x += (tx - pos.current.x) * 0.04;
    pos.current.y += (ty - pos.current.y) * 0.04;

    const bob = Math.sin(clock.elapsedTime * 0.45 + phase) * 0.12;
    meshRef.current.position.set(pos.current.x, pos.current.y + bob, base[2]);

    meshRef.current.rotation.x += rotSpeed;
    meshRef.current.rotation.y += rotSpeed * 0.7;
  });

  return (
    <mesh ref={meshRef} position={base}>
      {type === "torus"       && <torusGeometry       args={args} />}
      {type === "octahedron"  && <octahedronGeometry  args={args} />}
      {type === "icosahedron" && <icosahedronGeometry args={args} />}
      {type === "sphere"      && <sphereGeometry      args={args} />}
      <meshBasicMaterial color={color} wireframe transparent opacity={0.35} />
    </mesh>
  );
}

function FloatingShapes({ mouseRef, darkMode }) {
  const color = darkMode ? "#555555" : "#c8c8c8";

  return (
    <>
      {SHAPES.map((shape, i) => (
        <Shape key={i} {...shape} mouseRef={mouseRef} color={color} />
      ))}
    </>
  );
}

export default FloatingShapes;
